/**
 * Email canonicalization helper (Sprint C3a DK-20, Codex R2 F2/F3).
 *
 * Single source of truth für email normalisierung:
 * - trim() entfernt leading/trailing whitespace (User-Input " user@x.com ")
 * - toLowerCase() canonicalisiert case (Foo@X.COM → foo@x.com)
 *
 * **Order-Invariante:** normalize läuft VOR Zod-Validation:
 *   `z.string().email().min(1).parse(normalizeEmail(rawInput))`
 *
 * Sonst rejected Zod " user@x.com " als invalid email (whitespace), bevor
 * trim() greifen kann. Spec A5 + DK-20.
 *
 * **Verwendung — NUR email-input paths:**
 * - POST /api/auth/magic-link (lookup)
 * - POST /api/admin/users (storage + dedupe-lookup)
 *
 * **NICHT in:**
 * - POST /api/auth/verify — nutzt token_hash, kein email-input (Codex R2 F2)
 *
 * **DB-Level Defense:** `UNIQUE INDEX idx_users_email_lower ON LOWER(email)`
 * macht race-safe gegen concurrent inserts mit Mixed-Case-Variants
 * (Migration 0011 DK-3).
 */
export function normalizeEmail(input: string): string {
  return input.trim().toLowerCase();
}
